import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider, useSettings } from "@/context/SettingsContext";
import { InactivityProvider } from "@/context/InactivityContext";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { FloatingWhatsApp } from "@/components/layout/FloatingWhatsApp";
import HomePage from "@/pages/HomePage";
import EventsPage from "@/pages/EventsPage";
import StudioPage from "@/pages/StudioPage";
import InquiryPage from "@/pages/InquiryPage";
import NFCCardPage from "@/pages/NFCCardPage";
import AdminPage from "@/pages/AdminPage";

function AppContent() {
  const { settings } = useSettings();

  useEffect(() => {
    if (settings.site_title) {
      document.title = settings.site_title;
    }
  }, [settings.site_title]);

  return (
    <InactivityProvider>
      <div className="min-h-screen bg-background">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/studio" element={<StudioPage />} />
            <Route path="/inquiry" element={<InquiryPage />} />
            <Route path="/c/:id" element={<NFCCardPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </main>
        <Footer />
        <FloatingWhatsApp />
      </div>
      <Toaster theme="dark" position="top-right" />
    </InactivityProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <SettingsProvider>
          <BrowserRouter>
            <AppContent />
          </BrowserRouter>
        </SettingsProvider>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
